import { BUSINESS_SCENE, currentBusinessScene } from '@/local-conf';
import type { ComponentInternalInstance } from 'vue';

export default {
  update: () => {
    // #ifdef MP-WEIXIN
    const manager = uni.getUpdateManager();
    manager.onCheckForUpdate((res) => {
      // 请求完新版本信息的回调
      console.log(`<请求完新版本信息的回调>`, res);
    });
    manager.onUpdateReady(function () {
      uni.showModal({
        title: '更新提示',
        content: '新版本已经准备好，是否重启应用？',
        success(res) {
          if (res.confirm) {
            // 新的版本已经下载好，调用 applyUpdate 应用新版本并重启
            manager.applyUpdate();
          }
        },
      });
    });
    manager.onUpdateFailed((res) => {
      // 新的版本下载失败
      console.log('<新的版本下载失败>', res);
    });
    // #endif
  },
  isH5: () => {
    // #ifdef H5
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('micromessenger') !== -1;
    // #endif
  },
  getRect: (
    selector: string,
    instance: ComponentInternalInstance | null
  ): Promise<UniApp.NodeInfo | UniApp.NodeInfo[]> => {
    return new Promise((resolve) => {
      uni
        .createSelectorQuery()
        .in(instance)
        ['select'](selector)
        .boundingClientRect((rect) => {
          resolve(rect);
        })
        .exec();
    });
  },
  removeLog() {
    if (currentBusinessScene === BUSINESS_SCENE.wish) {
      console.log = () => {};
      console.info = () => {};
    }
  },
};
